import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function PaymentCancel() {
    return (
        <div className="min-h-screen pt-[68px] relative overflow-hidden" data-testid="payment-cancel-page">
            <div className="absolute inset-0 -z-10">
                <div className="absolute inset-0 grid-lines opacity-30" />
                <div className="absolute inset-0 bg-gradient-to-br from-[#0A0A0A] via-void to-[#050505]" />
            </div>
            <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-32">
                <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                    className="max-w-2xl border border-white/10 clip-frame bg-[#0A0A0A]/80 backdrop-blur-xl p-8 md:p-12">
                    <div className="overline mb-6">[ Payment · State Pass ]</div>
                    <h1 className="font-display font-black tracking-tighter text-4xl md:text-6xl leading-[0.9]">
                        Checkout <span className="text-outline-strong">canceled.</span>
                    </h1>
                    <p className="mt-6 text-secondary text-base leading-relaxed">
                        No charge was made. Your $20 State Pass is still waiting — it unlocks every qualifier in your home state plus all free cash cups.
                    </p>
                    <div className="mt-10 flex flex-wrap gap-4">
                        <Link to="/tournaments" className="btn-primary" data-testid="payment-cancel-back-cta">Back to tournaments →</Link>
                    </div>
                </motion.div>
            </div>
        </div>
    );
}
